import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, limit, onSnapshot, orderBy, query, setDoc, updateDoc, where } from 'firebase/firestore';
import React, { useEffect, useState }  from 'react';
import { firebase, functions, urls } from '../../../global/firebase';
import { Button, ButtonGroup, Card, CardList, Classes, Collapse, Dialog, DialogBody,  H3, H4, H5, Icon,  InputGroup,  Spinner, Tag, Toast } from '@blueprintjs/core';
import format from 'date-fns/format';
import { httpsCallable } from 'firebase/functions';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import domtoimage from 'dom-to-image';
import { strings } from '../../../components/justInComponents/strings';
import { VehiclePicksPage } from '../../../components/justInComponents/VehiclePicksPage';
import { redeemCouponFunction } from '../../../functions/redeemCoupon';
import { Refreshcoupons } from '../../../functions/refreshcoupons';
import { useAuthUser } from 'react-auth-kit';
import { substractRead } from '../../../global/documentreadcount';
import { DateInput3 } from '@blueprintjs/datetime2';
const getLoyaltyCycle = httpsCallable(functions, 'getLoyaltyCycle');
let usersnap:any = ()=>console.log('unsubscribe');
export  const ActiveCheckIns=(checkIn:any)=>{

    const [dataactive,setdataactive]=useState(checkIn)
    const [dateJoined ,setdateJoined]=useState('')
    const [loading ,setloading]=useState(true)
    const [user,setUser]=useState([] as any)
    const [userId,setUserId]=useState(null)
    const [getLoyaltyCycleText,setgetLoyaltyCycle]= useState('' as any)
    const [dialogCoupon,setdialogCoupon]=useState(false)
    const [guid,setguid]=useState('')
    const [coupons,setcoupons]=useState([] as any)
    const [handleClickOpenActiveCoupons,sethandleClickOpenActiveCoupons]=useState(false)
    const [handleClickOpenExpiredCoupons,sethandleClickOpenExpiredCoupons]=useState(false)
    const [activeCouponCount,setactiveCouponCount]=useState(0)
    const [expiredCouponCount,setexpiredCouponCount]=useState(0)
    const [business,setbusiness]=useState(checkIn['business'])
    const [note,setnote]=useState(null);
    const [Banned,setBanned]=useState(false)
    const [CheckedId,setCheckedId]=useState(false)
    const [markForTheft,setmarkForTheft]=useState(false)
    const [markForTheftDisabled,setmarkForTheftDisabled]=useState(false)
    const [BannedLoadig,setBannedLoadig]=useState(false)
    const [noteDialog,setnoteDialog]=useState(false)
    const [markForSellingCar,setmarkForSellingCar]=useState(false)
    const[militaryFirstResopnder,setmilitaryFirstResopnder]=useState(false)
    const [CheckedIdDisabled,setCheckedIdDisabled]=useState(false)
    const [militaryFirstResopnderDisabled,setmilitaryFirstResopnderDisabled]=useState(false)
    const [markForSellingCarDisabled,setmarkForSellingCarDisabled]=useState(false)
    const [downloadLoad,setdownloadLoad]=useState(false)
    const [justInModal,setjustInModal]=useState(false)
    const [Mobilex,setMobilex]=useState('')
    const [theme,settheme]=useState([] as any)
    const [lang,setlang]=useState(strings.eng)
    const [langstr,setlangstr]=useState('eng')
    const [feedType,setfeedType]=useState(checkIn['business'].feedType);
    const [InfoDialog,setInfoDialog]=useState(false)


    const [nameshow,setnameshow]= useState(false);
    const [mugshotshow,setmugshotshow]= useState(false);
    const [signatureshow,setsignatureshow]= useState(false);
    const [couponsshow,setcouponsshow]= useState(false);
    const [vehiclesshow,setvehiclesshow]= useState(false);
    const [languageshow,setlanguageshow]= useState(false);
    const [mobileshow,setmobileshow]= useState(false);
    const [timestampshow,settimestampshow]= useState(false);
    const [dateofbirthshow,setdateofbirthshow]= useState(false);
    const [emailshow,setemailshow]=useState(false);
    const [siteshow,setsiteshow]=useState(false);
    const [supercardshow,setsupercardshow]=useState(false);
    const [waivershow,setwaivershow]=useState(false);
    const [zipshow,setzipshow] =useState(false);
    const [isOptout,setisOptout] =useState(false);
    const [openvoidDialog,setopenvoidDialog]=useState(false)
    const [voidLoad,setvoidLoad]=useState(false)
    const [voidshow,setvoidshow]=useState(false)
    const [secretOn,setSecretOn]=useState(false)
    const [lasnameupdate,setlasnameupdate]=useState('')
    const auth:any = useAuthUser();

    const [NameEditDialog,setNameEditDialog]=useState(false)
    const [firstNameE,setfirstNameE]=useState('')
    const [lastnameE,setlastnameE]=useState('')

    const [dobEditDialog,setdobEditDialog] =useState(false);
    // const [dobE,setdobE]=useState('');
    
    const [zipEditDialog,setzipEditDialog] =useState(false);
    const [CashierUpdateButton,setCashierUpdateButton]=useState(false);
    const [zipE,setzipE]=useState('');
    const [dobE, setdobE] = useState<Date | null>(null)
    useEffect(()=>{   

      try {
        console.log('unsubscribe ',usersnap);
        usersnap();  
      
        if(checkIn['business']!==undefined && checkIn['business'].CashierUpdateButton!==undefined ){
          setCashierUpdateButton(checkIn['business'].CashierUpdateButton)
        }

        if(checkIn['checkIn']!==undefined && checkIn['checkIn'].name!==undefined && checkIn['checkIn'].name.firstname){
          setfirstNameE(checkIn['checkIn'].name.firstname)
        }

        if(checkIn['checkIn']!==undefined && checkIn['checkIn'].name!==undefined && checkIn['checkIn'].name.lastname){
          setlastnameE(checkIn['checkIn'].name.lastname)
        }

        if(checkIn['checkIn']!==undefined && checkIn['checkIn'].zip!==undefined){
          setzipE(checkIn['checkIn'].zip)
        }

        if(checkIn['checkIn']!==undefined && checkIn['checkIn'].dateofbirth!==undefined &&  checkIn['checkIn'].dateofbirth.seconds!==undefined ){

        const dd =checkIn['checkIn'].dateofbirth;
        
          setdobE(new Date(dd.seconds * 1000))
        }

      } catch (error) {
        console.log(error);
        
      }

      try {
        console.log('unsubscribe ',usersnap);
        usersnap();  
        
      } catch (error) {
        console.log(error);
        
      }
      try {
    
      try {
        console.log(auth().accountData);
       try {
       
      if(auth().accountData.permissions.ismask!==undefined && auth().accountData.permissions.ismask===true){
        setSecretOn(true)
      }

      } catch (error) {
          console.log(error);
          
      } 

        setvoidshow(checkIn['auth']().accountData.permissions.isVoidCheckIn)
      } catch (error) {
        console.log(error,'permissions error');        
      }


        getUser()         
        setbusiness(checkIn['business']) 

        if(checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out'){  
            
            const v:any =checkIn['checkIn']
            if(v!==undefined && v.businessId!==undefined && v.siteId!==undefined && v.mobile!==undefined && v.userId!==undefined){
            refreshCouponsx(v.businessId,v.mobile,v.userId,v.siteId)   
            getLastupdatedNamevalue(checkIn['checkIn'].userId)
            snapshortUserCoupons(v)   
            }
            setisOptout(false)
        }else if(checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId==='opt-out'){
            setcoupons([]) 
            setisOptout(true)
            Resetcomponent()
            setUser([])
        } else{
          setcoupons([])
          setisOptout(false)
          Resetcomponent()
          setUser([])
        }

        if(checkIn['checkIn']!==undefined){  
          setTimeout(() => {                   
        const signinsert = document.querySelector<HTMLElement>('#signone')!;
        let signS = 'Signature';
        let nameS = 'Name';
        let dateS = 'Date';
       
        
        if( checkIn['checkIn']!==null && checkIn['checkIn'].language!=='eng'){
           signS = 'Por';
           nameS = 'Nombre impreso';
           dateS = 'Fecha';
        }else{
          signS = 'Signature';
          nameS = 'Name';
          dateS = 'Date';
        }
        if(signinsert!==null){    
                     
          const signaturex =checkIn['checkIn']!==null && checkIn['checkIn'].signature!==null ? checkIn['checkIn'].signature  : checkIn['checkIn']!==null && checkIn['checkIn'].signatureUrl!==null ? checkIn['checkIn'].signatureUrl : checkIn['checkIn']!==null && checkIn['checkIn'].mugshot!==null ? checkIn['checkIn'].mugshot  : checkIn['checkIn']!==null && checkIn['checkIn'].mugshotUrl!==null ? checkIn['checkIn'].mugshotUrl : '';
          const namex = checkIn['checkIn']!==null ? checkIn['checkIn'].name.displayName : '';
          const datex = checkIn['checkIn']!==null ? checkIn['checkIn'].timestamp : '';
          const timestamp2 = datex!=='' ? format(datex.toDate(), "MM/dd/yyyy h:mma") : '';
        signinsert.innerHTML = '<div style="display:flex;"><div style="margin: auto;margin-left: 0px;margin-right: 0px;">'+signS+': </div><img width="40%" src="'+signaturex+'" /></div><div>'+nameS+': '+namex+'</div><div>'+dateS+': '+timestamp2+'</div>';
        }
        const signinserttwo = document.querySelector<HTMLElement>('#signtwo')!;
        if(signinserttwo!==null){
          const signaturex1 =checkIn['checkIn']!==null && checkIn['checkIn'].signature!==null ? checkIn['checkIn'].signature  : checkIn['checkIn']!==null && checkIn['checkIn'].signatureUrl!==null ? checkIn['checkIn'].signatureUrl : checkIn['checkIn']!==null && checkIn['checkIn'].mugshot!==null ? checkIn['checkIn'].mugshot  : checkIn['checkIn']!==null && checkIn['checkIn'].mugshotUrl!==null ? checkIn['checkIn'].mugshotUrl : '';
          const namex1 = checkIn['checkIn']!==null ? checkIn['checkIn'].name.displayName : '';
          const datex1 = checkIn['checkIn']!==null ? checkIn['checkIn'].timestamp : '';
          const timestamp21 = datex1!=='' ? format(datex1.toDate(), "MM/dd/yyyy h:mma") : '';
          signinserttwo.innerHTML = '<div style="display:flex;"><div style="margin: auto;margin-left: 0px;margin-right: 0px;">'+signS+': </div><img width="40%" src="'+signaturex1+'" /></div><div>'+nameS+': '+namex1+'</div><div>'+dateS+': '+timestamp21+'</div>';
        }

      }, 1500); 
      }

    checkIn['previewOptions'].map((x:any)=>{
      switch (x.name) {
       case 'name':
      if(x.enabled){   setnameshow(true)} else{ setnameshow(false) };
         break;
         case 'mugshot':
           if(x.enabled){   setmugshotshow(true)} else{ setmugshotshow(false) };
           break;
         case 'signature':
           if(x.enabled){   setsignatureshow(true)} else{ setsignatureshow(false) };
         break;
         case 'coupons':
           if(x.enabled){   setcouponsshow(true)} else{ setcouponsshow(false) };
         break;
         case 'vehicles':
           if(x.enabled){   setvehiclesshow(true)} else{ setvehiclesshow(false) };
         break;
         case 'mobile':
           if(x.enabled){   setmobileshow(true)} else{ setmobileshow(false) };
         break;
         case 'timestamp':
           if(x.enabled){   settimestampshow(true)} else{ settimestampshow(false) };
         break;
         case 'dateofbirth':
           if(x.enabled){   setdateofbirthshow(true)} else{ setdateofbirthshow(false) };
         break;
         case 'language':
           if(x.enabled){   setlanguageshow(true)} else{ setlanguageshow(false) };
         break;
         case 'site':
           if(x.enabled){   setsiteshow(true)} else{ setsiteshow(false) };
         break;
         case 'email':
           if(x.enabled){   setemailshow(true)} else{ setemailshow(false) };
         break;
         case 'supercard':
           if(x.enabled){   setsupercardshow(true)} else{ setsupercardshow(false) };
         break;
         case 'waiver':
           if(x.enabled){   setwaivershow(true)} else{ setwaivershow(false) };
         break;
         case 'zip':
           if(x.enabled){   setzipshow(true)} else{ setzipshow(false) };
         break;
                                                                            
       default:
         break;
      }
     })
     
         
    } catch (error) {
        console.log(error,'error');
        
    }
    },[checkIn['checkIn'],checkIn['previewOptions']])

const getLastupdatedNamevalue=async(userId:any)=>{
try {

  const lastupdatednamevalue =(await getDoc(doc(collection(firebase,'userUpdateLog'),userId))).data();

  if(lastupdatednamevalue!==undefined && lastupdatednamevalue.lastUpdatedDate!==undefined && lastupdatednamevalue.lastUpdatedDate!==''){
    console.log(lastupdatednamevalue.lastUpdatedDate.seconds,lastupdatednamevalue,'>>>>>>>>>>>>><<<<<<<<<<<<<<<');
    
      setlasnameupdate(lastupdatednamevalue.lastUpdatedDate.seconds)
  }else{
    setlasnameupdate('')
  }

  
  
} catch (error) {
  console.log(error,'getLastupdatedNamevalue');
  
}
}


const Resetcomponent=()=>{

  setnote(null);
  setBanned(false)
  setCheckedId(false)
  setmarkForTheft(false)
  setmarkForTheftDisabled(false)
  setBannedLoadig(false)
  setnoteDialog(false)
  setmarkForSellingCar(false)
  setmilitaryFirstResopnder(false)
  setCheckedIdDisabled(false)
  setmilitaryFirstResopnderDisabled(false)
  setmarkForSellingCarDisabled(false)
}
  
const getUser=async()=>{
    try {
console.log('hit get user function');

    if(checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out'){
      setdataactive(checkIn['checkIn'])
        setUserId(checkIn['checkIn'].userId)
        // const ddd =(await getDoc(doc(collection(firebase,'users'),checkIn['checkIn'].userId))).data();
        
        const note =(await getDoc(doc(collection(firebase,'notes'),checkIn['checkIn'].userId))).data();
        substractRead(1)
        if(note!==undefined){
          if(checkIn['checkIn'].businessId!==undefined && note.businessId!==undefined &&  checkIn['checkIn'].businessId==note.businessId){          
         setnote(note.note)
          }
        }else{
         setnote(null)
        }
        try {
            checkIn['users'].map((row:any)=>{

                if(row.userId===checkIn['checkIn'].userId){
                  setUser(row)
                }
            });  

      } catch (error) {
        console.log(error,'error');
        
      }

    
    setloading(false)

    // setdataactive(checkIn['checkIn'])

    if(checkIn['checkIn'].bannedCustomerOption!==undefined){      
      console.log(checkIn['checkIn'].bannedCustomerOption);     
      setBanned(checkIn['checkIn'].bannedCustomerOption)
     }else{
       setBanned(false)
     }

     if(checkIn['checkIn'].checkedIdCustomer!==undefined){      
      console.log(checkIn['checkIn'].checkedIdCustomer);     
      setCheckedId(checkIn['checkIn'].checkedIdCustomer)
     }else{
      setCheckedId(false)
     }

     if(checkIn['checkIn'].markForTheft!==undefined){      
      console.log(checkIn['checkIn'].markForTheft);     
      setmarkForTheft(checkIn['checkIn'].markForTheft)
     }else{
      setmarkForTheft(false)
     }
     console.log(checkIn['checkIn'])
     if(checkIn['checkIn'].markForSellingCar!==undefined){      
      console.log(checkIn['checkIn'].markForSellingCar);     
      setmarkForSellingCar(checkIn['checkIn'].markForSellingCar)
     }else{
      setmarkForSellingCar(false)
     } 

    if(checkIn['checkIn'].militaryFirstResopnder!==undefined){      
      console.log(checkIn['checkIn'].militaryFirstResopnder);     
      setmilitaryFirstResopnder(checkIn['checkIn'].militaryFirstResopnder)
     }else{
      setmilitaryFirstResopnder(false)
     }
  
     
    
    try {
    getDateJoined(checkIn['checkIn'].businessId,checkIn['checkIn'].siteId,checkIn['checkIn'].mobile)  
    const businessGuid =checkIn['business']!==undefined && checkIn['business']!==null ? checkIn['business']['guid'] : null ;
    let data = {
        guid:businessGuid,
        kiosk:'',
        mobile: checkIn['checkIn'].mobile,
      };

 if(checkIn['checkIn'].businessId!=='' && checkIn['checkIn'].siteId!==''){        
    
        if(checkIn['sites']!==undefined && checkIn['sites']!==null){
          checkIn['sites'].map((rw:any)=>{
            if(rw.siteId===checkIn['checkIn'].siteId){

            settheme(rw)
            data.guid= (rw.guid!==undefined && rw.guid!==null && rw.guid!=='' )? rw.guid : data.guid;
            data.kiosk  =checkIn['checkIn']!==undefined && checkIn['checkIn']['language']!==undefined && checkIn['checkIn']['language']==='en' ? rw.kioskName : rw.kioskNameEs;

            }
          })
        }
        
    }
   
    getLoyaltyCycle(data)
    .then((result) => {
      const data:any = result.data;
      setgetLoyaltyCycle(data)  
      setloading(false)    
    }).catch((e)=>{
      console.log(e);
      setgetLoyaltyCycle('....')  
      setloading(false) 
      
    });         
    } catch (error) {
       console.log(error);            
    }

    }else if(checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId==='opt-out'){
      setdataactive(checkIn['checkIn'])
    }
          
  } catch (error) {
      console.log(error);
      
  }
}

const getDateJoined=async(b:any,s:any,m:any)=>{
  try {
 
    let quer:any =[]
    if(s!==null && s!==''){
        quer =await getDocs(query(collection(firebase,'checkIns'),where('businessId','==',b) ,
        where('siteId','==',s),where('mobile','==',m),orderBy("timestamp",'asc'),limit(1)))
    }else{
        quer =await getDocs(query(collection(firebase,'checkIns'),where('businessId','==',b),where('mobile','==',m),orderBy("timestamp",'asc'),limit(1)))
    }

    try {
      substractRead(quer.size)
    } catch (error) {
      console.log(error,'join date query');
      
    }

if(quer.docs[0]!==undefined && quer.docs[0]!==null){
try {  
    setdateJoined(format((quer.docs[0].data().timestamp).toDate(), "MM/dd/yyyy h:mma"))
  } catch (error) {
  console.log(error);
  
  }
}
   
} catch (error) {
    console.log(error,'');
    
}
}


const onclickMore=async(bool:any)=>{ 
    setdialogCoupon(bool)      
}


const removeNote=async()=>{
    setnote(null)
    await deleteDoc(doc(collection(firebase,'notes'),checkIn['checkIn'].userId));
    await getDocs(query(collection(firebase,'checkIns'),where('userId','==',checkIn['checkIn'].userId))).then(async(res:any)=>{
      substractRead(res.size)
      if(res.size>0){
            res.docs.map(async(r:any)=>{  
                await updateDoc(doc(firebase, `checkIns`,r.id), {
                    markUserNotes:false,
                })
            })
      }
    });
    checkIn.updateField({markUserNotes:false},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
    if(checkIn['checkInsAll'].length>0){
     checkIn['checkInsAll'].filter((x:any)=>{
         if(x.userId===checkIn['checkIn'].userId){
           x.markUserNotes = false;
         }
         return x
 
       });
     }

}

const addNote=async()=>{    
    setloading(true)
      try {
  
    await setDoc(doc(firebase, "notes",checkIn['checkIn'].userId), {
        businessId: checkIn['checkIn'].businessId,
        checkInId: checkIn['checkIn'].mainId,
        createdAt: new Date().getTime(),
        mobile:checkIn['checkIn'].mobile,
        note
      });
      
    await getDocs(query(collection(firebase,'checkIns'),where('userId','==',checkIn['checkIn'].userId))).then(async(res:any)=>{
         substractRead(res.size)
          if(res.size>0){
                res.docs.map(async(r:any)=>{               
                   await updateDoc(doc(firebase, `checkIns`,r.id), {
                    markUserNotes:true,
                })
              });
            }
    })

    checkIn.updateField({markUserNotes:true},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
    if(checkIn['checkInsAll'].length>0){
     checkIn['checkInsAll'].filter((x:any)=>{
        if(x.userId===checkIn['checkIn'].userId){
          x.markUserNotes = true;
        }
        return x

      });
   
    }
    setloading(false)
    setnoteDialog(false)
          
  } catch (error) {
        console.log(error);
        
  }


}


const snapshortUserCoupons=async(v:any)=>{
try {
console.log('hit snapshot user coupons');

    const docRef =query(collection(firebase, `users/${v.userId}/coupons`))
  usersnap =    onSnapshot(docRef,(dart:any)=>{
      if(!dart.empty){  
        try {
          substractRead(dart.size)                         
        } catch (error) {
          console.log(error,'coupon error');
        }
        setcoupons(dart.docs);
        let a=0;
        let ex =0;
        dart.docs.map((xt:any,i:any)=>{
            if(expiresDateCheck(xt.data().expires_date)  || (xt.data().redemption_flag!==undefined && xt.data().redemption_flag) ){
                    ex++
            }else{
                    a++
            }
            setactiveCouponCount(a)
            setexpiredCouponCount(ex)
            setloading(false)

      })
    }else{
      setactiveCouponCount(0)
      setexpiredCouponCount(0)
        setcoupons([]);
    }
     })    
     
} catch (error) {
  console.log(error,'iu90');
  
}    
  }
  
  const expiresDateCheck=(date:any)=>{
    try {
 
  const dd=  new Date();
  const seconds = dd.getTime() / 1000;
  try {
 
  if(seconds>date.seconds){    
  return true
  }else{
    return  false
  }
     
} catch (error) {
    return  false
}

     
} catch (error) {
     console.log(error);
      
}
  }
  
  
  
const callRefreshCoupons = async (
      businessId: string,
      guid: string,
      mobile: string,
      userId: string,
      token:string,
    ) => {
      
      // const url =
      //   "https://us-central1-dev-just-in-north.cloudfunctions.net/refreshCustomerCoupons";
    const url =urls.toolsandautomated+"refreshCustomerCoupon"
  
      try {
       const data:any = {businessId,guid,mobile,userId,token };
       await Refreshcoupons(data) 
        console.log("querying coupons....");      
  
      } catch (err) {
        console.log(err,'error');
      }
    };
  
    const refreshCouponsx = async (
      businessId: string,
      mobile: string,
      userId: string,
      siteId?: string
    ) => {
      try {

      // refresh coupons
      console.log("starting coupon refresh....");
 
    
        // const docRef =query(collection(firebase, `businesses`),where('businessId','==',businessId)) 
        // const queryx =await getDocs(docRef);        
      const businessGuid =checkIn['business']!==undefined && checkIn['business']!==null ? checkIn['business']['guid'] : null ;
      const businesstoken =checkIn['business']!==undefined && checkIn['business']!==null ? checkIn['business']['businesstoken'] : null ;
      if (businessGuid!==null && businessGuid!=='') {   
      callRefreshCoupons(businessId, businessGuid, mobile, userId,businesstoken);
      }
        // now do this for every site
      // const quersite = query(collection(firebase, `businesses/${businessId}/sites`))
      const sitesQuery = checkIn['sites']!==undefined ? checkIn['sites'] :[];
      sitesQuery.map((doc:any) => {
        const siteGuid = doc['guid'];
        if (siteGuid) {
          callRefreshCoupons(businessId, siteGuid, mobile, userId,businesstoken);
        }
      });
        console.log('coupon refreshed sucessfully');
              
    } catch (error) {
        console.log(error,'refresh coupon error');
        
    }
    };

const redeemCoupon=async(v:any,bool:any)=>{
  try {
 
    if(bool===false && userId!==null){
        setloading(true)
        const busienssId = v.data().businessId
        
        const dartx = checkIn['users'].filter((v:any)=>v.userId===userId)[0];    
        console.log(dartx,'check reedeem users work');
            
        const busines =checkIn['business']!==undefined && checkIn['business']!==null ? business : null

       const dart = await updateDoc(doc(firebase, `users`,userId,'coupons',v.id), {
          redemption_flag:true,
      }).then(async()=>{
        if(busienssId && busines!==null && busines.businesstoken!==undefined && busines.businesstoken){
            const url =urls.toolsandautomated+"redeemCustomerCoupon"
            try {
              console.log("querying redeem coupons....");
              await redeemCouponFunction(
                v.id,
                userId,
                busines.businesstoken,
                dartx.mobile
            )
            } catch (err) {
              console.log(err);
              setloading(false)
            }

          }
    }); 
    console.log(dart);
    }
       
  } catch (error) {
    console.log(error);
    
  }
}

const prettyMobile = (mobile: string) => {
    const areaCode = mobile.substring(0, 3);
    const prefix = mobile.substring(3, 6);
    const suffix = mobile.substring(6, 10);
  
    return `(${areaCode}) ${prefix}-${suffix}`;
  };

const UpdateCheckin=async(res:any)=>{
  if(res.bannedCustomerOption!==undefined){ setBannedLoadig(true);  setBanned(res.bannedCustomerOption) }
  if(res.checkedIdCustomer!==undefined){ setCheckedIdDisabled(true);   setCheckedId(res.checkedIdCustomer) }
  if(res.markForTheft!==undefined){ setmarkForTheftDisabled(true); setmarkForTheft(res.markForTheft) }
  if(res.markForSellingCar!==undefined){ setmarkForSellingCarDisabled(true); setmarkForSellingCar(res.markForSellingCar) }
  if(res.militaryFirstResopnder!==undefined){ setmilitaryFirstResopnderDisabled(true); setmilitaryFirstResopnder(res.militaryFirstResopnder) }

    if(checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out'){
     const docs= await getDocs(query(collection(firebase,'checkIns'),where('userId','==',checkIn['checkIn'].userId)))   
     if(docs.empty===false){
      substractRead(docs.size)
      docs.docs.map(async(x:any)=>{  
        console.log('update checkins');
             
          await updateDoc(doc(firebase, `checkIns`,x.id), res)
       });
      // checkIn.refreshCheckIn()
     }

     if(res.bannedCustomerOption!==undefined){setBannedLoadig(false); }


     
     if(res.markForTheft!==undefined){
       setmarkForTheftDisabled(false);
       checkIn.updateField({markForTheft:res.markForTheft},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
      }
     if(res.markForSellingCar!==undefined){
      setmarkForSellingCarDisabled(false)
      checkIn.updateField({markForSellingCar:res.markForSellingCar},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
     }
     if(res.militaryFirstResopnder!==undefined){
       setmilitaryFirstResopnderDisabled(false)
       checkIn.updateField({militaryFirstResopnder:res.militaryFirstResopnder},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
      }


     if(res.bannedCustomerOption!==undefined){
      await updateDoc(doc(firebase, `users`,checkIn['checkIn'].userId), res)       
        setBannedLoadig(false)
        // checkIn.refreshCheckIn()        
        checkIn.updateField({bannedCustomerOption:res.bannedCustomerOption},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
     }

     if(res.checkedIdCustomer!==undefined){
      await updateDoc(doc(firebase, `users`,checkIn['checkIn'].userId), res)
        setCheckedId(res.checkedIdCustomer)
        setCheckedIdDisabled(false)
        // checkIn.refreshCheckIn()
        checkIn.updateField({checkedIdCustomer:res.checkedIdCustomer},checkIn['checkIn'].userId,checkIn['checkIn']['mainId'])
     }


    try {
      
        if(checkIn['checkInsAll'].length>0){
          checkIn['checkInsAll'].filter((x:any)=>{
            if(x.userId===checkIn['checkIn'].userId){
              if(res.checkedIdCustomer!==undefined){
                x.checkedIdCustomer = res.checkedIdCustomer;
              }
              if(res.bannedCustomerOption!==undefined){
                x.bannedCustomerOption = res.bannedCustomerOption;
              }
              if(res.militaryFirstResopnder!==undefined){
                x.militaryFirstResopnder = res.militaryFirstResopnder;
              }
              if(res.markForSellingCar!==undefined){
                x.markForSellingCar = res.markForSellingCar;
              }
              if(res.markForTheft!==undefined){
                x.markForTheft = res.markForTheft;
              }

            }
            return x

          });
        
        }

    } catch (error) {
      console.log(error);
      
    }

    }

}



const downloadPDF =  async () => {
  setdownloadLoad(true)
      setTimeout( async () => {
      const  checkInf  =checkIn['checkIn'] ;
      console.log(checkInf,'for download waiver ');
      
      (window as any).html2canvas = html2canvas;
      const input = document.querySelector<HTMLElement>("#WaiverTextWrapper")!; 
      
      let heightofPdf: any = 0;
      if (checkInf ) {
            if(input!==null){
              heightofPdf = input.clientHeight;
            }else{
              heightofPdf =0;
            }
        const doc = new  jsPDF({
          orientation: 'p', // landscape
          unit: 'pt', // points, pixels won't work properly
          format: [900,heightofPdf+500] // set needed dimensions for any element
    });

        doc.setFontSize(11);
        doc.text(
          "Mobile: " + checkInf.mobile !== "opted-out" &&  checkInf.mobile !== "" &&  checkInf.mobile !== "6028181729"
            ? prettyMobile(checkInf.mobile ? checkInf.mobile : "")
            : "opted out",
          50,
          30
        );
        doc.text(format(checkInf.timestamp.toDate(), "M/d/yyyy h:mma"), 410, 30);

        if (checkInf.mugshot) {
          doc.addImage(checkInf.mugshot, 50, 60, 200, 200);
        } else {
          let mugshot: any = null;
          mugshot = await urlToImg(checkInf.mugshotUrl);
          if(checkInf.mugshotUrl !== null && typeof mugshot !== 'undefined'){
            doc.addImage(mugshot, 50, 60, 200, 200);
          }
        }

        if (checkInf.signature) {
          doc.addImage(checkInf.signature, 300, 160, 250, 100);
        } else {
          let signature: any = null;
          signature = await urlToImg(checkInf.signatureUrl);
          if(checkInf.signatureUrl !== null && typeof signature !== 'undefined'){
            doc.addImage(signature, 300, 160, 250, 100);
          }
        }

        let str = checkInf.sitePath;
        if (checkInf.businessPath) {
          if (checkInf.name.displayName) {
            str =
              checkInf.name.displayName +
              " at " +
              checkInf.businessPath +
              " " +
              checkInf.sitePath;
          } else {
            str = checkInf.businessPath + " " + checkInf.sitePath;
          }
        }
        doc.text(str,50, 300);
        
        domtoimage.toPng(input, { cacheBust: true })
        .then( async (dataUrl) =>  {
          let image: any = null;
          image =  await urlToImg(dataUrl);
          doc.addImage(image, 80, 320, image.width, image.height);
          doc.save("waiver.pdf");
          setdownloadLoad(false)
        })
        .catch((err) => {
          console.log(err)
          setdownloadLoad(false)
        });
        }        
    }, 3000);
};


const urlToImg = (url: string | null) => {
  if (!url) {
    return;
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onerror = (err) =>{ reject(err);  setdownloadLoad(false)};
    img.onload = () => {
      resolve(img);
    };
  });
};

const showJustInModal=()=>{
  setjustInModal(true)
}

const searchFunction=()=>{
  if(isOptout){
  checkIn.searchByNumber('')
  }else if(user && user.mobile){
    checkIn.searchByNumber(user.mobile)  
  }

}


const voidThisCheckIn=async()=>{
  setvoidLoad(true)    
await  addDoc(collection(firebase,'voidedCheckIns'),checkIn['checkIn'])
await deleteDoc(doc(firebase, "checkIns",checkIn['checkIn']['mainId']));
  setvoidLoad(false) 
  setopenvoidDialog(false)
  checkIn.refreshCheckIn()
}


const obscureMobile = (value: string) => {
  const valueArr = value.split("");
  valueArr[4] = "*";
  valueArr[5] = "*";
  valueArr[6] = "*";
  return valueArr.join("");
};

const maskNumber = (num: any) => {
  const x = num.toString().match(/(\d{3})(\d{3})(\d{4})/);
  return "(" + x[1] + ")" + " *** " + x[3];
};


const renderdob = (v: any): string => {
  try {
    if (v && v.seconds) {
      const date = new Date(v.seconds * 1000); // Convert Unix seconds to JavaScript Date
      return format(date, "MM/dd/yyyy"); // Ensure correct format
    } else if (v !== undefined && v !== null && v !== "") {
      const date = v instanceof Date ? v : new Date(v);
      
      return format(date, "MM/dd/yyyy"); // Correct format for "03/08/25 1:26PM"
    } else {
      return ".....";
    }
  } catch (error) {
    console.error("Error formatting date:", error);
    return ".....";
  }
};



const editNameofUser=()=>{
  setNameEditDialog(true)
}

const savedobdata=async()=>{
  if(checkIn['checkIn']!==undefined){

    if(checkIn['checkIn'].userId!=='opt-out'){


     await updateDoc(doc(firebase,'checkIns',checkIn['checkIn'].mainId),{dateofbirth:new Date(dobE ??''),kioskSubmission:false,ivisionUpdate:true})
     await updateDoc(doc(firebase,'users',checkIn['checkIn'].userId),{dateofbirth:new Date(dobE ??'')})
      setdobEditDialog(false)
      checkIn.refreshCheckIn()
    }

}
}

const savezipdata=async()=>{
  if(checkIn['checkIn']!==undefined){

    if(checkIn['checkIn'].userId!=='opt-out'){

     await updateDoc(doc(firebase,'checkIns',checkIn['checkIn'].mainId),{zip:zipE,kioskSubmission:false,ivisionUpdate:true})
     await updateDoc(doc(firebase,'users',checkIn['checkIn'].userId),{zip:zipE})
      setzipEditDialog(false)
      checkIn.refreshCheckIn()
    }

}
}

const savenamedata=async()=>{
  if(checkIn['checkIn']!==undefined){

      if(checkIn['checkIn'].userId!=='opt-out'){
        const name ={
          displayName:firstNameE+' '+lastnameE,
          firstname:firstNameE,
          lastname: lastnameE,
        }

       await updateDoc(doc(firebase,'checkIns',checkIn['checkIn'].mainId),{name,kioskSubmission:false,ivisionUpdate:true})
       await updateDoc(doc(firebase,'users',checkIn['checkIn'].userId),{name})
        setNameEditDialog(false)
        checkIn.refreshCheckIn()
      }

  }
}


  const handlezipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, ""); 
    if (value.length > 5) {
      setzipE(zipE);
    }else{

    setzipE(value);
    }
  };

  const formatDate = (date: Date) => date.toLocaleString().split(',')[0];
  const parseDate = (str: string) => new Date(str);
return(
    <div className='activeCheckIn' style={{color:business!==undefined && business.checkInsOptions!==undefined ? business.checkInsOptions.tableFontColor:''}}>
{/* for name */}
<Dialog               
               isOpen={NameEditDialog}
               onClose={()=>setNameEditDialog(false)}
               // title="Information" 
               title={
                 <div>
                     <span className="left_table_info_icon" style={{ float:"left" }}>&nbsp;</span>&nbsp;&nbsp; Update Name
                 </div>
               } 
             >
<DialogBody>
 <H5> &nbsp;First Name</H5>
 <InputGroup
 onChange={(e:any)=>setfirstNameE(e.target.value)}
 defaultValue={firstNameE}
 />
 <br/>
<H5> &nbsp;Last Name</H5>
 <InputGroup
 onChange={(e:any)=>setlastnameE(e.target.value)}
 defaultValue={lastnameE}
 />

 <Button intent='success' onClick={savenamedata} style={{float:'right',marginTop:'10px'}}>Save</Button>
</DialogBody>
  </Dialog>
  {/* End name */}

  {/* for zip */}
  <Dialog               
               isOpen={zipEditDialog}
               onClose={()=>setzipEditDialog(false)}
               // title="Information" 
               title={
                 <div>
                     <span className="left_table_info_icon" style={{ float:"left" }}>&nbsp;</span>&nbsp;&nbsp; Update Zip
                 </div>
               } 
             >
<DialogBody>
 <H5> &nbsp;Zip</H5>
 <InputGroup
 type='number' max={5}
 min={1}
 onChange={handlezipChange}
//  defaultValue={zipE}
 value={zipE}
 />


 <Button intent='success' onClick={savezipdata} style={{float:'right',marginTop:'10px'}}>Save</Button>
</DialogBody>
  </Dialog>
  {/* end zip */}

  {/* for dob */}
  <Dialog               
               isOpen={dobEditDialog}
               onClose={()=>setdobEditDialog(false)}
               // title="Information" 
               title={
                 <div>
                     <span className="left_table_info_icon" style={{ float:"left" }}>&nbsp;</span>&nbsp;&nbsp; Update Date Of Birth
                 </div>
               } 
             >
<DialogBody>
 <H5> &nbsp;Date Of Birth</H5>
 {/* <InputGroup
      type="date"
      value={dobE ? renderdob(dobE) : ""}
      onChange={(e) => setdobE(new Date(e.target.value))}
    /> */}
<DateInput3
  value={dobE?.toString()}
  onChange={(selectedDate) => {
    if (selectedDate) {
      const parsedDate = new Date(selectedDate); // safely parse from string or Date
      const localDate = new Date(
        parsedDate.getUTCFullYear(),
        parsedDate.getUTCMonth(),
        parsedDate.getUTCDate()
      );
      setdobE(localDate);
    }
  }}
  
  locale={navigator.language || "en-US"} 
  formatDate={(date: Date) => {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }}
  parseDate={(str: string) => {
    const [mm, dd, yyyy] = str.split("/");
    if (!mm || !dd || !yyyy) return null;
    let parsed = new Date(str)
    console.log(parsed);
    
    if((new Date().toTimeString().slice(9)).includes('india')){
       parsed = new Date(`${yyyy}-${mm}-${dd}`);
    }
    
    const localDate = new Date(
      parsed.getUTCFullYear(),
      parsed.getUTCMonth(),
      parsed.getUTCDate()
    );
    return isNaN(localDate.getTime()) ? null : parsed;
  }}
  placeholder="MM/DD/YYYY"
  minDate={new Date("1900-01-01")}
  maxDate={new Date("2100-12-31")}
/>


 <Button intent='success' onClick={savedobdata} style={{float:'right',marginTop:'10px'}}>Save</Button>
</DialogBody>
  </Dialog>
  {/* end dob */}


        <div className='rowx'>
            <div className='col-50'></div>
            <div className='col-50 text-right'>
            <div>
              <Icon size={25} color='white' onClick={()=>setInfoDialog(true)} style={{ cursor:"pointer" }} intent='primary' icon='info-sign'/>
              <Dialog
                style={{ width:"50%" }}
                isOpen={InfoDialog}
                onClose={()=>setInfoDialog(false)}
                // title="Information" 
                title={
                  <div>
                      <span className="left_table_info_icon" style={{ float:"left" }}>&nbsp;</span>&nbsp;&nbsp; Information
                  </div>
                } 
              >
                <div className={Classes.DIALOG_BODY}>
                  <p>
                    <b>Download Waiver:</b> First, find the waiver you are searching for with filter by Name, Phone Number, Date, or scrolling through check-ins.  Then, download the waiver with the blue Download Waiver button and look for the .pdf download at the top right or bottom left of your screen. On Google Chrome, the .pdf download is at the bottom left. On Microsoft Edge, the .pdf download is at the top right. 
                  </p>
                  <img src={require("../../../assets/images/image0.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image1.jpg")} style={{ marginBottom:'15px' }} />
                  <p>
                    <b>Add Note:</b> To add a note on a specific customer, find and select their check-in. Next, select the green Add Note button. Type in your note and select Add Note. A green note will pop-up above the buttons on the left table and the note will show up every time this Phone Number checks in. You can undo the note with the gray back button next to Add Note. Also, you will see a green asterisk icon underneath the Phone Number field on the right table every time a customer with an Active Note checks in.
                  </p>
                  <img src={require("../../../assets/images/image2.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image3.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image4.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Theft Prevention:</b> To ban a customer from the yard, then find the customer check-in and select the red Theft Prevention button. This will add a red triangle with an exclamation point underneath the Phone Number field on the right table. If this customer checks in again with the same Phone Number, then the icon will show up underneath their number on the right table. To undo Theft Prevention for a customer, select the silver undo button next to the Theft Prevention button.  Theft Prevention will not prevent customers from checking in with a different number unless that Phone Number is also banned.
                  </p>
                  <img src={require("../../../assets/images/image5.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image6.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Ca$h for Cars:</b> To categorize a customer as a potential source for inventory, then select the customers check-in and the gold Ca$h for Cars button. This will add a gold star underneath this customer in the Phone Number field on the right table. To undo this icon, select the silver undo button next to the Ca$h for Cars button.
                  </p>
                  <img src={require("../../../assets/images/image7.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image8.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Military/First Responder:</b> To recognize a customer as United States military or first responder, then select the check-in and blue Military/First Responder button. This will add the American flag underneath their Phone Number on the right table. Every time this customer checks in, then the American flag icon will display. You can undo this with the silver back button.
                  </p>
                  <img src={require("../../../assets/images/image9.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image10.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Add/Edit Vehicle Picks:</b> : To add a new vehicle pick for a customer, then select the correct check-in and the green Add/Edit Vehicle Picks button. Select Year Range (optional), Make, and Model. The Phone Number auto-populates based on which check-in was selected when the Add a New Pick button was selected. Once the information is complete, then select the green Next button. The next page will show all vehicle picks this customer has active. It will also show whether or not there is any new inventory (added within the last seven days) matches for each vehicle pick. If there is, then you will see a green car with a checkmark next to the pick. You will also see how many days are left for each pick before they expire. You can delete picks for the customer with the red x button on the left and renew picks with the button at the right. Renewing a pick will change the number of days left for that pick to 90 days.
                  </p>
                  <p>
                    To edit your existing picks, select Add/Edit Vehicle Picks and then Edit Picks to access the dashboard for a particular customer. 
                  </p>
                  <img src={require("../../../assets/images/image11.jpg")} style={{ marginBottom:'7px' }} />
                  <br />
                  <img src={require("../../../assets/images/justin_alert.png")} style={{ height:'300px', marginBottom:'15px' }} />


                  <p>
                    <b>Vehicle icon:</b> A vehicle icon will show up underneath the Phone Number field for customers who have active vehicle picks. To see which vehicle picks a customer has active, then select a check-in with a vehicle icon and look in the left column for Vehicle Picks.
                  </p>
                  <img src={require("../../../assets/images/image12.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/image13.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Coupon icon:</b> When customers have active mobile coupons, then you will see a white rectangle with a percent sign underneath Phone Number. To see which coupons this customer has active, select the check-in on the right table and the Coupons data field on the left table will display how many coupons are available for this customer. Select the green Active Coupons button to see which coupons are active.  Coupons are redeemed here or on the mobile phone in the text the customer received.  To see detail on each coupon, select the down arrow on the left side of the coupon.  This will display the description and expiration date.  Once the coupon is redeemed, then it is added to the statistics on the Coupon Summary Report.
                  </p>
                  <img src={require("../../../assets/images/image14.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Customer History:</b> To see the history of a customer checking in, then select the customer in the right table and then select the magnifying glass next to their number on the top of the left table.  This will give you a total check-ins above the right table where it says Check-ins by user and you can find any previous Check-In you are looking for in the right table.
                  </p>
                  <img src={require("../../../assets/images/chk1.png")} style={{ height:'210px', marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../assets/images/chk2.png")} style={{ height:'210px', marginBottom:'15px' }} />

                  <p>
                    <b>Search by Phone Number:</b> Type number into search field and select silver magnifying glass to search. All check-ins associated with this Phone Number will display in the right table.  A total count is listed next to Check-ins by user. Select one of the check-ins to Download Waiver, add Note, add icons, or Add/Edit Vehicle Picks.
                  </p>
                  <img src={require("../../../assets/images/image15.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Search by Name:</b> Type name into search field and change left filter from Phone Number to Name. Next, select the silver magnifying glass. All check-ins for this Name will show up in the right table. All check-ins associated with this Phone Number will display in the right table.  A total count is listed next to Check-ins by user. Select one of the check-ins to Download Waiver, add Note, add icons, or Add/Edit Vehicle Picks.
                  </p>
                  <img src={require("../../../assets/images/image16.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Search by Date:</b> Select Date with the calendar icon.  Select Month, Year, and Date last. Check-ins will display in right table with newest check-ins first for that day.  So, the last check-in of the day will display first.
                  </p>
                  <img src={require("../../../assets/images/image17.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Show 35, 150, 250, 500, 750, or 1000:</b> Select Show 35 and change to a higher number to display more check-ins in the right table on the first page.  This prevents having to go to the next page if you want to scroll through a lot of check-ins.
                  </p>
                  <img src={require("../../../assets/images/image18.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Go to next page or back to the last page:</b> Use the left and right arrows next to page number to traverse forward to the next page or back to the last page. It might be easier to adjust the Show number instead of changing the page number.
                  </p>
                  <img src={require("../../../assets/images/image19.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Location:</b> The all drop-down allows the ability to select one location.  Once a location is selected, only check-ins from that location will display in the right table.  If displaying all location check-ins, then the Location field will confirm the location. 
                  </p>
                  <img src={require("../../../assets/images/image20.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Change Right Table Defaults:</b> Select the settings icon.  Make changes to the default columns by changing Table Columns or the right column in View Options. The default displays Name, Phone Number, Time, Picture, Date, and Location from left to right. To change the order of how the data is displayed from left to right, then you can use the up and down arrows. Moving data elements up will move them to the left in the right column. To add data fields that are currently not displayed, then you can toggle on and off by selecting the data element.
                  </p>
                  <img src={require("../../../assets/images/image21.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Void Check-In:</b> Select the check-in you want to void. Then, you want to scroll down on the left table and select the red Void Check-In button. A popup will display asking you to confirm you want to void this check-in. Voids cannot be undone.
                  </p>
                  <img src={require("../../../assets/images/image22.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Go To Kiosk:</b> Select location first from all drop-down.  Next, select Go To Kiosk and a new window is created which redirects to the kiosk.
                  </p>
                  <img src={require("../../../assets/images/image23.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Quick Stats:</b> This is an excellent resource for getting a quick snapshot of statistics.  On the Check-Ins page, you can select Daily, Weekly, or Monthly from the drop-down.  Daily will show statistics for the current day. Weekly shows statistics over the last 7 days. Monthly shows statistics over the last 30 days. Check-Ins is the total number of Check-Ins that were completed within the time period selected.  Kiosk Opt-Outs is the total number of times customers checked in, but opted-out of providing their phone number during the same timeframe.  Re-Checks are the total number of times customers checked in for the second or more times during the same day.  Voids are the total number of times Check-Ins were deleted or voided out of the system for the same timeframe.
                  </p>
                  <img src={require("../../../assets/images/image24.png")} style={{ marginBottom:'15px' }} />

                </div>
              </Dialog>      
           </div>
            <br />
              </div>
        </div>
        <div className='rowxTag'>
        <div className='col-50'>
        {nameshow ? <H3 style={{color:business!==undefined && business.checkInsOptions!==undefined && (business.darkmode===undefined && business.darkmode===false) ? business.checkInsOptions.tableFontColor : (business.darkmode!==undefined && business.darkmode===true) ? '#fff' : '#000'}} className='text-light text-left'>{checkIn['checkIn']!==undefined && checkIn['checkIn'].name!==undefined && checkIn['checkIn'].name.displayName!==undefined ? checkIn['checkIn'].name.displayName : ''}  {CashierUpdateButton && checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out' ? <Button onClick={()=>editNameofUser()} small={true} intent='primary'><Icon icon='edit'/></Button>: ''}</H3>:''}
        </div>
        
        <div className='col-50'>
         {mobileshow ? <H3 style={{color:business!==undefined && business.checkInsOptions!==undefined && (business.darkmode===undefined && business.darkmode===false) ? business.checkInsOptions.tableFontColor : (business.darkmode!==undefined && business.darkmode===true) ? '#fff' : '#000'}} className='text-light'> {user!==undefined && user.mobile!==undefined ? secretOn===true ?  maskNumber(user.mobile) :prettyMobile(user.mobile) : isOptout ? 'opted-out' : ''}
          &nbsp;<Button className='border-20'><Icon icon='search' size={20} onClick={()=>searchFunction()}/></Button></H3>:''}
        </div>
        {/* <div className='col-50'>
        {nameshow ? <H3 style={{color:business!==undefined && business.checkInsOptions!==undefined && (business.darkmode===undefined && business.darkmode===false) ? business.checkInsOptions.tableFontColor : (business.darkmode!==undefined && business.darkmode===true) ? '#fff' : '#000'}} className='text-light text-left'>{user!==undefined && user.name!==undefined   ? user.name.displayName :  isOptout && checkIn['checkIn']!==undefined && checkIn['checkIn'].name!==undefined ? checkIn['checkIn'].name.displayName : ''}</H3>:''}
        </div>
        
        <div className='col-50'>
         {mobileshow ? <H3 style={{color:business!==undefined && business.checkInsOptions!==undefined && (business.darkmode===undefined && business.darkmode===false) ? business.checkInsOptions.tableFontColor : (business.darkmode!==undefined && business.darkmode===true) ? '#fff' : '#000'}} className='text-light'> {user!==undefined && user.mobile!==undefined ? secretOn===true ?  maskNumber(user.mobile) :prettyMobile(user.mobile) : isOptout ? 'opted-out' : ''}
          &nbsp;<Button className='border-20'><Icon icon='search' size={20} onClick={()=>searchFunction()}/></Button></H3>:''}
        </div> */}

        </div>
        <div style={{float:'right',position:'relative',right:'10px'}}>
{checkIn['checkIn']!==undefined && checkIn['checkIn'].kind===undefined ? <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAjCAYAAAAAEIPqAAAAAXNSR0IArs4c6QAACV1JREFUWEfFV3lYU1cW/733EkhCUNYQAu4LoJRhFLUwVkX53EHtFK1bxa2opWPrUkGroraWop91rQ51pdqO4lpRVBQXxH3cS2t1cCMkECEsJiR5Sd58LzEhYQtU/Xr/et89y/3dc37n3PMI/EWrdOykrvpCqb9P7umTzYVANNfAkb7Mp91V3+LHvRrTK5716UD95u0nCS/vXRLFkzhHPmvL3zjoIhfvYsLV1egrL/CtD0zxuClR+p/3ZrMywsWlXPKyxP0vBy3luGlhoJ2o4OBj4ntXh9sCUsSOH6fbf3iP7Z4fo2p24Jpt4CgqUkLIAIxJjRsZ+akoJ3Mj+10yOHoqfTJna237hkArN25s456Q8LS+894CaBcz4ldL8MWcUGOVaoJm87/nsVseJ9RQ/pMPS4CdRg2SeB88KGNlxVFDPjLk5G5nGIaSMCqSsNy+FvImga5Ys6lj9enTgeLjhzIdRhoCRqxQQy5yqaPqeV4Np2AGqnQKlZ/zTHKyXfvrxqdPusNoJC0GREu3h5JyaeeGzmoSaNZYSgqNYBiC9BH/jx8X28MtJUVZn1MpXBjfMhUMJUBJUA1wrztqcP1rkiDzrHspiz/u0vm+ouRk+WuDlgV0m2/840Gq1RFBMESXoBTJ/esLbZ1LCRfGt1Rl2qo+RaJ8LB+iRypQtXqEzMvFnHwGaLlDg4rJPIDlA8Wh/fUVTo1ltMmRNkWbMPOVG64HfZlTg9/JuZLbt0//kojQe+5rU7XiArVVZqQBklsXgvYWAedu5prVPyagCBOYlLh9ew8RnTt54s2Bdve/hXJlKNGSAQvMUAkoggXWojId2tUArwsaR9THC5knBEIVBK4aKML50P9hpnRTWmCzIl2VlORdmbK+hHUuVqhAWEsHeLmZQtWXPDhH0/DYqWsQdFmxGzzE5Qjp1gUrZwRg+MeHIPMw85ugSJqMfG+SOPv4zw4j/XzfPj45Jk4NkCCFQjkjdD1MCYUH6OC2t/wPHSq1dVDEaalnDHqKP56G2/qGwdV36LcfL4ROS2Dxrq8xf+wsOPP1WBS9DeXTzJ3EdpFC10pqYL9+ogP/uVVbZo102YIFratTN9o1c24PPejrNdw1lQ2XrwNd7cxyke0SjpbRCCwevwCT5v+CrPThqFQ6mUAXP/dBwpTeyMg+AMYIFHcUgKmoP/Gkp6hErCjwIwhCb8qI7aGKmDHjdUczd9vumYBZOhVb3RqAziegOcYBf4we3E52b4nVlN3dvXIqJi7ahj7hEeBzBPhwQEcUFniaQLMnJ42di3EJ2Xgn4q7ZjgDUGRQq4utG3uKYlPhn1LmarFe/HcZr162TFyfUAO8zjgvL9qKFj/xwNzcM01Iv426OEbGxQQjwaY/Wws7QQ40lLGgA305bijnffwWuk6FOwjS5JJQj+ea7cDg0FRq6QnTt3FcE22rrS2+RuMNNplj+d4vMI1ttbk8O1o/fTEVqRh4m9x6MOevXYllcIm4X5kOlq8bhrAuI7B+MYYGDsGTXyrqeCED1I4mqeXwwNPtUkuB/NG6i+/Yte1igtgYNdg+pUKSESuVmURaXquy5ZOPlt+tBmJQgQETrXli2ZTce3gpEWNQ1MAwwMmqYSXN/VhZ+WjUZI+L3w82rwg60vK0ATFUNFP43i908EhPtlWws6gVdGhM7WHP0eJZFz2mAHp4Z2jrjS15mb3j7K9Ap5AG6dO+E5XE9sWHfY/T064HVGetM+sXPxFj6r2is3ZMOnou2wVwp3uNBn09Z5ZKcTC4RGWkqvNqrpnukpLRWJ6deJrRaiUXJdZUGwil1+WaRT4+Zhk6tXPDFpnWYOSoegBGrd/0EikNj09z5mLvZzN36Vsm7PLgu1YE/zMiamVbFci7U61694CRp8DNU2bUuix+iqFXAcaawcEhtx16X1OAG1OXxjBHxuFx4Ecf2VuBcxkDsynqC7NwcnNg5HGt3aNGrbQiuPr6L71ZLEdQjv0HQ1ZkUyifZdwneCBqcXka8XOhssiMEgkrflyVudTjNMAxRvmFDSPXspFtMrRbIGnrdUIPbrgb85gWfIPvmc1yTXsWs8GlYn7cFt085w1MsR1RkBJbMFmDA6FMNgrUKCFhfQvbpZhiGLO7V9wfjjZtx7Lc1qmKfhxJZgd2YasdpWXx8F+P2vfegp20eaLO5+4Fq8PoZ8Ti/Pf7xwUs8yFPhkwkjkfvsPL4cNQJTl29qFCj9CNBeoCCcarDWRuloZ+jOcEB1D4sX3zifZuuABa4I6x1heCb9mvF0k0p+vz3OepH6TlIcOSKhY+N+Y2hdC1s5J9AA70sa9A5/F7NHd0DsZ3vwS9r7GBF/0NQpzDkF9HICHB97aul+JVDaxzzJcToZ4JmjAUEBcol57mjKoNQoaItQsW2bKz17UQmjqjKRzytPDW4gg6UTE8F35iJx64o6d1bvo1AxkwfRExUo1xqx9r8EygYK4Dp9hrc67+JKQ/796WDz+aoIuRHhSaK80ymOeVUPh2sbFVEtDIzRYKKL3ZPegHfrcA/Ap0AFsqVZUXuJQFm0AMYPhgpaZWRUs3vFg2NC9GfzLkOnMaWgqdFudDRl1qzhF81dbJroud0N8Dpl/5zTBQRe9BDA8qeilxJQhAjAmxUXrPl+533WzkeqAskDNGcIKEcLIDmWwSOGDrVr2Cx/ZW2CjlNubld87l5JdhTtRkEXtQo8yBQ+H8U68b6pBqeNub8opzlBc7Dmd8TjrBrOIQxKuvJhkJOmiJWu/8FfM/uz56ytWK6C5iSJ8kn8JkezMeCNgrb8XrEvm/dtNV704ds9t9bCEDAQP1VD5u0CqkPH3eJHdyaystKkxeGalDWX2O8WGzWoTOC9XdAlMRM60kcPPax9Y4IgDM5L5oV4Jifny7zbnje+UPRhdZwH09Ce4EJifEkRBPGqvADl9Jkx6q3pRyx+msrbPxVpmYf/faNS2dViTPr5ZWlWJL3fbvJkK7HPJidzOi9bxc5k5sV10vjplOZ50mYpoqI/153JWdOcYvtToFlqMBRF8z6MHe21e9vhhpwUidr+zigUASbMIe+MEd25sq8+XXnXnhsM+b8mvLVIl6en93908WJuWFpaTRQbQM3s2MErmpJgamGOAMk7/u2k+NGdQY66gyN5s/7GG4x2S9/noKgXkrJC64+Do4NfR/5GQJcnJrqry8pcJWlpz14HTFNt/w/EVJ8kHA5DGAAAAABJRU5ErkJggg==" height="35" width="45"></img>
:''}        </div>
        <div className='rowx'>
          {note!==null ? <span style={{textAlign:'left'}}>
          <Toast icon='asterisk' intent='success' isCloseButtonShown={false} message={<div>{note} <br/>
          <Button style={{float:'right'}} intent='warning' onClick={()=>removeNote()} small={true}>Close</Button></div>}  />            
            </span> :''}
         </div>
       {checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out' ? 
       <div className='rowx' style={{float: 'left',textAlign:'left'}}>
       {waivershow ? <button className='customButton waiverbtn' disabled={downloadLoad} onClick={downloadPDF}>{!downloadLoad ? 'Download Waiver' : 'Please wait...'}</button>:''}
       {/* {business.proMembership!==undefined && business.proMembership===true ?  <button className='customButton waiverbtn'>Pro membership</button>: ''} */}
       {checkIn['checkIn']!==undefined && checkIn['checkIn'].markUserNotes!==undefined && checkIn['checkIn'].markUserNotes===true ? '' : <button onClick={()=>setnoteDialog(true)} className='customButton addnote'>Add Note</button>}
       {business.bannedCustomerOption!==undefined && business.bannedCustomerOption===true  ?  ( Banned===false ?<button disabled={BannedLoadig} onClick={()=>UpdateCheckin({bannedCustomerOption:true})} className='customButton Bannedbtn'>Banned Customer</button> : <button disabled={BannedLoadig}  onClick={()=>UpdateCheckin({bannedCustomerOption:false})} className='customButton UnBannedbtn'>UnBanned</button>) : ''}
       {business.CheckedIdOption!==undefined && business.CheckedIdOption===true ? ( CheckedId===false ?<button disabled={CheckedIdDisabled} className='customButton Checkedbtn'  onClick={()=>UpdateCheckin({checkedIdCustomer:true})}>Checked-ID</button> : <button disabled={CheckedIdDisabled} className='customButton Uncheckedbtn' onClick={()=>UpdateCheckin({checkedIdCustomer:false})}>UnChecked-ID</button>) : ''}     
       {business.markForTheftSwitch!==undefined && business.markForTheftSwitch===true ?  (markForTheft===false ? <button disabled={markForTheftDisabled} className='customButton Bannedbtn'  onClick={()=>UpdateCheckin({markForTheft:true})}>Theft Prevention</button> : <button disabled={markForTheftDisabled} className='customButton Theftrevokebtn' onClick={()=>UpdateCheckin({markForTheft:false})}>Revoke Theft Prevention</button>  ) :''}
       {business.markForSellingCarSwitch!==undefined && business.markForSellingCarSwitch===true ?  (markForSellingCar===false ? <button disabled={markForSellingCarDisabled} className='customButton Carsbtn' onClick={()=>UpdateCheckin({markForSellingCar:true})} >Ca$h for Cars</button> : <button disabled={markForSellingCarDisabled} className='customButton revokeCarsbtn'  onClick={()=>UpdateCheckin({markForSellingCar:false})}>Revoke Ca$h for Cars</button> ): ''}
       {business.militaryFirstResopnderSwitch!==undefined && business.militaryFirstResopnderSwitch===true ? (militaryFirstResopnder===false ? <button disabled={militaryFirstResopnderDisabled} className='customButton Militarybtn' onClick={()=>UpdateCheckin({militaryFirstResopnder:true})}>Military/First Responder</button> : <button disabled={militaryFirstResopnderDisabled} className='customButton revokeMilitarybtn' onClick={()=>UpdateCheckin({militaryFirstResopnder:false})}>Revoke Military/First Responder</button>  ) : ''}
        {business.addaNewPickSwitch!==undefined && business.addaNewPickSwitch===true && vehiclesshow ?  <button className='customButton addnote' onClick={()=>showJustInModal()}>Add/Edit Vehicle Picks</button>  : ''}     
        </div>: 
        <div className='rowx' style={{float: 'left',textAlign:'left'}}>
          {waivershow ? <button className='customButton waiverbtn' disabled={downloadLoad} onClick={downloadPDF}>{!downloadLoad ? 'Download Waiver' : 'Please wait...'}</button>:''} 
          </div>
        }

        {mugshotshow ?<div className='rowx' >
            <img width={'80%'} style={{marginTop:'10px'}} src={dataactive.mugshot!==undefined && dataactive.mugshot!==null ? dataactive.mugshot : dataactive.mugshotUrl}/>
        </div>:''}
        {signatureshow ?<div className='rowx'>
            <img width={'80%'} src={dataactive.signature!==undefined && dataactive.signature!==null ? dataactive.signature : dataactive.signatureUrl}/>
        </div>:''}

        <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Date Joined</Button>} >
             {dateJoined}</Tag>
        </div>
        {couponsshow && !isOptout ? <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Coupons</Button>} > 
        <Button className='couponbtn' fill={true} intent={coupons.length>0 ? 'success' :'danger'} onClick={()=>onclickMore(true)}>Coupons ({activeCouponCount})</Button>
        </Tag>
        </div>:''}
        {languageshow ? <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Language</Button>} >
             {dataactive.language!==undefined && dataactive.language!==null  && dataactive.language==='en' ? 'English' : 'Spanish' }</Tag>
        </div>:''}
       {isOptout ? '' : <div   className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Next Coupon:</Button>} >{getLoyaltyCycleText ?getLoyaltyCycleText:'...' }</Tag>
        </div>}
        <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Re-Check</Button>} > 
           {dataactive.kind!==undefined && dataactive.kind==='recheck'  ? 'Yes' : 'No' }</Tag>
        </div>
        {timestampshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Timestamp</Button>} > 
       {dataactive['timestamp']!==undefined && dataactive['timestamp']!==null ? format(dataactive['timestamp'].toDate(), "MM/dd/yyyy h:mma"):''}
        </Tag>
        </div>:''}
        
        {dateofbirthshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Date Of Birth</Button>} > 
       {'dateofbirth' in dataactive && dataactive['dateofbirth']!==undefined && dataactive['dateofbirth']!==null  ?  renderdob(dataactive['dateofbirth'])  : 'No Date of Birth'}&nbsp;&nbsp;
       {checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out' && CashierUpdateButton ? <Button onClick={()=>setdobEditDialog(true)} small={true} intent='primary'><Icon icon='edit'/></Button>: ''}
        </Tag>
        </div>:''}

        {zipshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Zip</Button>} > 
       {'zip' in dataactive  && dataactive['zip']!==undefined && dataactive['zip']!==null ? dataactive['zip'] : ''}&nbsp;&nbsp;
       {checkIn['checkIn']!==undefined && checkIn['checkIn'].userId!==undefined && checkIn['checkIn'].userId!=='opt-out'&& CashierUpdateButton  ? <Button onClick={()=>setzipEditDialog(true)} small={true} intent='primary'><Icon icon='edit'/></Button>: ''}
        </Tag>
        </div>:''}

        {emailshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Email</Button>} > 
       {dataactive['email']!==undefined && dataactive['email']!==null && 'email' in dataactive ? dataactive['email'] : ''}
        </Tag>
        </div>:''}

        {supercardshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Supercard</Button>} > 
       {dataactive['supercard']!==undefined && dataactive['supercard']!==null && 'supercard' in dataactive ? dataactive['supercard'] : ''}
        </Tag>
        </div>:''}

        {siteshow ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Site</Button>} > 
       {dataactive['sitePath']!==undefined && dataactive['sitePath']!==null && 'sitePath' in dataactive ? dataactive['sitePath'] : ''}
        </Tag>
        </div>:''}


        {lasnameupdate ?  <div  className='rowxTag'>
        <Tag className='tagcss' key={1}  fill={true}  icon={<Button className='tagbtn'>Last name updated: </Button>} > 
       {lasnameupdate!==undefined && lasnameupdate!=='' ? new Date(parseInt(lasnameupdate,10)*1000).toLocaleDateString() : ''}
        </Tag>
        </div>:''}

          
    
       {waivershow ?  <div  className='rowxTag'>
        <p className='waivertext' id='WaiverTextWrapper' dangerouslySetInnerHTML={{ __html: dataactive.waiver!==undefined && dataactive.waiver!==null  ? dataactive.waiver : '' }}>     
           </p>
        </div>:''}
<br/>
{voidshow ? <div style={{margin:'10px'}}>
  <Button intent='danger' onClick={()=>setopenvoidDialog(true)}>Void Check-In</Button>
</div>:''}
<Dialog title="Are you sure you want to void this check-in?" icon='asterisk' isOpen={openvoidDialog} onClose={()=>setopenvoidDialog(false)}>
    <div style={{padding:'20px'}}>  
    <H3>This action cannot be undone!</H3>      
            <ButtonGroup>         
            <Button onClick={()=>setopenvoidDialog(false)}>cancle</Button>&nbsp;&nbsp;&nbsp;
            <Button intent='danger' loading={voidLoad}  onClick={()=>voidThisCheckIn()}>void</Button>
            </ButtonGroup>
    </div>
    </Dialog>
        

    <Dialog onClose={()=>setdialogCoupon(false)} title="Coupons" icon="info-sign" isOpen={dialogCoupon}>
      {coupons[0]!==undefined && coupons[0]!==null ?   <H4>&nbsp;Coupons ({coupons.length})</H4>:''}
        {coupons[0]!==undefined && coupons[0]!==null ? 
            <div className='m-5'>
            <Button fill={true} intent='success' onClick={()=>sethandleClickOpenActiveCoupons(!handleClickOpenActiveCoupons)}>
                {handleClickOpenActiveCoupons ? "Hide" : "Show"} Active Coupons ({activeCouponCount})
            </Button>
            <Collapse isOpen={handleClickOpenActiveCoupons}>
            <CardList>                    
                {coupons.length>0 ?
                coupons.map((xt:any,i:any)=>(
                    !expiresDateCheck(xt.data().expires_date) && (xt.data().redemption_flag!==undefined && !xt.data().redemption_flag) ? <Card key={i} interactive={true}>
                       <span>{xt.data().coupon_name}</span> 
                        <Button className='ml-auto' 
                        onClick={()=>redeemCoupon(xt,(xt.data().redemption_flag))}
                        disabled={xt.data().redemption_flag} loading={loading} intent='success' small={true} text={xt.data().redemption_flag ? 'Redeemed' : 'Redeem'} />
                        </Card>:''
                    ))
               :'' }
                </CardList>
            </Collapse>            

        {/* // expires */}
        <Button fill={true} intent='danger' style={{marginTop:'20px'}}   onClick={()=>sethandleClickOpenExpiredCoupons(!handleClickOpenExpiredCoupons)}>
            {handleClickOpenExpiredCoupons ? "Hide" : "Show"} Expired Coupons ({expiredCouponCount})
        </Button>
        <Collapse isOpen={handleClickOpenExpiredCoupons}>
        <CardList>                    
            {coupons.length>0 ?
            coupons.map((xt:any,i:any)=>(
                expiresDateCheck(xt.data().expires_date) || (xt.data().redemption_flag!==undefined && xt.data().redemption_flag) ? <Card key={i} interactive={true}>
                   <span>{xt.data().coupon_name}</span> 
                  {expiresDateCheck(xt.data().expires_date) ?  <Button className='ml-auto' disabled  intent="danger" small={true} text="Expired" />: <Button className='ml-auto' disabled  intent="success" small={true} text="Redeemed" />}
                    </Card> : ''
                ))
           :'' }
            </CardList>
        </Collapse>            
    </div>
        :
       <Spinner                   
            intent={'primary'}
            size={50}  
                />
      }
    </Dialog>

    {/* note */}
    <Dialog title="Add Note" icon='asterisk' isOpen={noteDialog} onClose={()=>setnoteDialog(false)}>
    <div style={{padding:'20px'}}>
             <textarea cols={60} style={{marginBottom:'5px',width:'100%'}} rows={7} onChange={(e:any)=>setnote(e.target.value)}></textarea>             
             <Button intent='success' disabled={loading} loading={loading} onClick={addNote}>Add</Button>
    </div>
    </Dialog>
        

    <Dialog   isOpen={justInModal} onClose={()=>setjustInModal(false)} lazy={true} >
    <DialogBody className="text-center" >
{checkIn['checkIn']!==undefined && checkIn['checkIn']!==null ? <VehiclePicksPage
            lang={langstr}
            strings={lang}
            callBack={(e:any,str:any)=>{setlangstr(str); setlang(e)}}
            businessId={checkIn['checkIn'].businessId}
            siteId={checkIn.siteId}
            showVehiclePicks={(e:any)=>console.log(e)}
            busienssPath={checkIn['checkIn'].busienssPath}
            sitePath={checkIn['checkIn'].sitePath}
            mobile={checkIn['checkIn'].mobile}
            logo={null}
            feedType={feedType}
            theme={theme}
                />:''}
    </DialogBody>
</Dialog>
    </div>
)

}